import AOS from 'aos';
import vars from './helpers';

AOS.init({
	delay: 150,
	once: true,
	offset: 50,
	duration: 300,
	disable: vars.isMobile(),
});
